import React from 'react'
import { PageLinkContainer } from './styled'
import createClassName from '../../utils/createClassName'
import Text from '../Text'
import Box from '../Box'
import { PageLinkRootProps } from './Pagination.types'

const PageLink: React.FC<PageLinkRootProps> = ({
  className,
  active,
  disabled,
  children,
  pageNum,
  ...restProps
}) => {
  const classes = createClassName(
    'RnPagelink',
    {
      active,
      disabled,
    },
    className,
  )

  return (
    <PageLinkContainer
      justifyContent='center'
      alignItems='center'
      width='32px'
      height='32px'
      borderRadius='50%'
      cursor='pointer'
      className={classes}
      aria-current={active ? `page-${pageNum}-active` : `page-${pageNum}`}
      aria-label={isNaN(pageNum) ? `page-more` : `page-${pageNum}`}
      {...restProps}
    >
      <Box as='a' position='relative'>
        {disabled ? (
          children
        ) : (
          <Text variant='body' weight={active ? 'bold' : 'regular'}>
            {children}
          </Text>
        )}
      </Box>
    </PageLinkContainer>
  )
}

export default PageLink
